import React from 'react';
import moment from "moment"
import {IScreenshot} from "../types";
import {
    Breadcrumb,
    Button, ButtonToolbar,
    Card,
    Col,
    Container,
    Form, InputGroup, Modal,
    Row,
    Table, ToggleButton, ToggleButtonGroup
} from 'react-bootstrap'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import {IMAGE_BASE_URL} from "../../../../../utils/globalConstant";

interface AlarmScreenshotPageProps {
    screenshots: IScreenshot[]
    onBack: () => void
    userAccount: string
    pcName: string
    alarm: string
}

const AlarmLogScreenshots: React.FC<AlarmScreenshotPageProps> = ({ screenshots, onBack, userAccount, pcName, alarm}) => {
    return (
        <>
            {/*<Card className="border-0 shadow-sm mb-4">*/}
                <Row>
                    <Col sm={6}>
                        <Button style={{fontSize: '90%'}} variant="transparent" className="text-decoration-none ps-0 text-muted fw-light" onClick={onBack}>
                            <FontAwesomeIcon icon={faArrowLeft} /> Back
                        </Button>
                    </Col>
                </Row>

            <Row className={'mb-2'}>
                <Col sm={12}>
                    <Row>
                        <h5 className="text-center fw-bold mb-4" style={{ flexGrow: 1, margin: 0 }}>Alarm Log Screenshots</h5>
                    </Row>
                    <Row className={'mb-5'}>
                        <Col md={6}>
                            <Row >
                                <Col sm={4} className="fw-bold">User Account:</Col>
                                <Col>{userAccount}</Col>
                            </Row>
                            <Row >
                                <Col sm={4} className="fw-bold">PC Name:</Col>
                                <Col>{pcName}</Col>
                            </Row>
                            <Row>
                                <Col sm={4} className="fw-bold">Alarm:</Col>
                                <Col>{alarm}</Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>

            </Row>

            <Row  className={'mb-4'}>
                        {screenshots.length > 0 ?
                            <>
                                <Row>
                                    {screenshots.slice(0, 12).map((screenshot, index) => (
                                        <Col key={index} md={2} className="mb-3">
                                            <a href={IMAGE_BASE_URL + screenshot.screenshot} target="_blank" className="photo-a" rel="noreferrer">
                                                <Card className="h-100">
                                                    <Card.Img variant="top" src={IMAGE_BASE_URL + screenshot.screenshot} style={{ height: "150px", objectFit: "cover" }} />
                                                    <Card.Body className="p-2" style={{ fontSize: '80%' }}>
                                                        <small className="text-muted">
                                                            {moment(screenshot.created_at).format("hh:mm A")}
                                                        </small>
                                                    </Card.Body>
                                                </Card>
                                            </a>
                                        </Col>
                                    ))}
                                </Row>
                            </>
                            : <Table responsive size="sm">
                                <tbody>
                                <tr>
                                    <td className={'text-center'}>No Screenshots to show.</td>
                                </tr>
                                </tbody>
                            </Table>
                        }
                    {/*</Card.Body>*/}
                {/*</Card>*/}
            </Row>
        </>
    )
}

export default AlarmLogScreenshots;